import {testIds} from '@dms/routes';
import {DmsDataGrid} from '@dms/shared';

import {useBusinessCasesActionCallback} from '../../hooks/useBusinessCasesActionCallback';

export function BusinessCaseList() {
  const [actionCallback] = useBusinessCasesActionCallback();

  return (
    <DmsDataGrid
      gridCode="business-case"
      actionCallback={actionCallback}
      data-testid={testIds.businessCase.home('bussinessCaseList')}
    />
  );
}
